import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { OrganizationResponse } from './organization-response';
import { OrganizationRequest } from './organization-request';
import { UpdateOrganizationRequest } from './update-organization-request';
import { OrganizationDomainIsTaken } from './org-domain-is-taken';
import { OrganizationWorkspacesResponse } from './organization-workspaces-response';

@Injectable({
  providedIn: 'root',
})
export class OrganizationsHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE) private readonly apiBase: string
  ) {}

  get(): Observable<OrganizationResponse[]> {
    return this.httpClient.get<OrganizationResponse[]>(`${this.apiBase}/organizations`);
  }

  getMines(): Observable<OrganizationResponse[]> {
    return this.httpClient.get<OrganizationResponse[]>(`${this.apiBase}/organizations/my`);
  }

  getMyOrgById(id: string): Observable<OrganizationResponse> {
    return this.httpClient.get<OrganizationResponse>(`${this.apiBase}/organizations/${id}/my`);
  }

  getById(id: string): Observable<OrganizationResponse> {
    return this.httpClient.get<OrganizationResponse>(`${this.apiBase}/organizations/${id}`);
  }

  create(request: OrganizationRequest): Observable<OrganizationResponse> {
    return this.httpClient.post<OrganizationResponse>(`${this.apiBase}/organizations`, request);
  }

  update(id: string, request: UpdateOrganizationRequest): Observable<OrganizationResponse> {
    return this.httpClient.put<OrganizationResponse>(`${this.apiBase}/organizations/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBase}/organizations/${id}`);
  }

  domainIsTaken(request: OrganizationDomainIsTaken): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.apiBase}/organizations/domain-taken`, request);
  }

  getOrganizationWorkspaces(organizationId: string): Observable<OrganizationWorkspacesResponse> {
    return this.httpClient.get<OrganizationWorkspacesResponse>(`${this.apiBase}/organizations/${organizationId}/workspaces`);
  }
}
